import { Mention } from '@tiptap/extension-mention';
import { ReactNodeViewRenderer } from '@tiptap/react';

import type { ResourceOrQuery } from '../../resources';

import { MentionToken } from './MentionTokenView';

export interface MentionStorage {
  resources: ResourceOrQuery[];
}

export const VegaMention = Mention.extend({
  name: 'mention',

  addStorage() {
    return {
      resources: [] as ResourceOrQuery[],
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      resourceType: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-resource-type'),
        renderHTML: (attributes: Record<string, string>) => {
          if (!attributes.resourceType) {
            return {};
          }
          return { 'data-resource-type': attributes.resourceType };
        },
      },
    };
  },

  addNodeView() {
    // eslint-disable-next-line new-cap -- ReactNodeViewRenderer is a Tiptap factory, not a constructor
    return ReactNodeViewRenderer(MentionToken);
  },
});
